export default class Navigation {
    constructor (query) {
        const items = document.querySelectorAll(query);
        if (!items || !items.length) throw new Error('Dashboard navigation items not found');

        this.items = [...items];

        this.init();
    }

    init () {
        const { pathname } = window.location;

        this.items.forEach((item) => {
            for (let i = 0; i < 3; i++) {
                const key = item.dataset[`key-${i}`];

                if (key && pathname.includes(`/${key}/`)) {
                    item.classList.add('current');
                }
            }
        });
    }
}
